if (!Object.hasOwn) {
  Object.hasOwn = function hasOwn(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property)
  }
}
